import React, { Component } from 'react';
import moment from 'moment';

class LocalStorageChecker extends Component {
  constructor(props) {
    super(props);
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
    this.removeOldReportsFromLocalStorage = this.removeOldReportsFromLocalStorage.bind(this);
  }

  // Limpa todos os dados do local storage
  clearLocalStorage() {
    localStorage.clear();
  }

  // Remove os dados do local storage que sejam de relatórios com mais de 2 dias
  removeOldReportsFromLocalStorage() {
    // Remove completamente as instancias antigas de localStorage
    // flight_report_legs_states_by_id e flight_report_legs_states_new_by_id
    localStorage.removeItem('flight_report_legs_states_by_id');
    localStorage.removeItem('flight_report_legs_states_new_by_id');

    const twoDaysAgo = moment().subtract(2, 'days');

    // Remove os registros de mais relatórios de mais de 2 dias de flight_reports_index
    let flightReportsIndexObj = JSON.parse(localStorage.getItem('flight_reports_index')) || { flight_reports_index: [] };
    let flightReportsIndex = flightReportsIndexObj.flight_reports_index || [];
    let filteredFlightReportsIndex = flightReportsIndex.filter(report => 
      moment(report.date_str, 'DD/MM/YYYY').isAfter(twoDaysAgo)
    );
    flightReportsIndexObj.flight_reports_index = filteredFlightReportsIndex;
    localStorage.setItem('flight_reports_index', JSON.stringify(flightReportsIndexObj));

    // Remove os registros de mais relatórios de mais de 2 dias de flight_reports_by_id
    let flightReportsById = JSON.parse(localStorage.getItem('flight_reports_by_id')) || {};
    let filteredFlightReportsById = Object.keys(flightReportsById).reduce((acc, id) => {
      const report = flightReportsById[id];
      if (moment(report.flight_report.date, 'YYYY-MM-DD').isAfter(twoDaysAgo)) {
        acc[id] = report;
      }
      return acc;
    }, {});
    localStorage.setItem('flight_reports_by_id', JSON.stringify(filteredFlightReportsById));

    // Remove os registros de mais relatórios de mais de 2 dias de cached_flight_report_legs_states_by_id
    let flightReportLegsStatesById = JSON.parse(localStorage.getItem('cached_flight_report_legs_states_by_id')) || {};
    let filteredFlightReportLegsStatesById = Object.keys(flightReportLegsStatesById).reduce((acc, id) => {
      const leg = flightReportLegsStatesById[id];
      const reportId = leg.flight_report_id;
      if (filteredFlightReportsById[reportId]) {
        acc[id] = leg;
      }
      return acc;
    }, {});
    localStorage.setItem('cached_flight_report_legs_states_by_id', JSON.stringify(filteredFlightReportLegsStatesById));

    // Remove os registros de mais relatórios de mais de 2 dias de cached_flight_report_legs_states_new_by_id
    let flightReportLegsStatesNewById = JSON.parse(localStorage.getItem('cached_flight_report_legs_states_new_by_id')) || {};
    let filteredFlightReportLegsStatesNewById = Object.keys(flightReportLegsStatesNewById).reduce((acc, id) => {
      const legs = flightReportLegsStatesNewById[id];
      if (filteredFlightReportsById[id]) {
        acc[id] = legs;
      }
      return acc;
    }, {});
    localStorage.setItem('cached_flight_report_legs_states_new_by_id', JSON.stringify(filteredFlightReportLegsStatesNewById));
  }

  render() {
    return null;
  }
}

export default LocalStorageChecker;


// WEBPACK FOOTER //
// ./src/Components/Miscelania/LocalStorageChecker.js